<!-- 
Expander panel showing the levy cap calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelLevyCap)"
    >
      Calculation breakdown: Levy cap adjustment
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.LevyCap"/>
        <v-card-text class="pa-0">
          <our-data-container right fluid>
            <our-data-field v-if="minimumCap" label="Levy cap" label-width="3">
              Minimum cap of the per provider administrative fee applies 
              = 
              {{ levyCollection.administrationFeePerProvider | currency }}
            </our-data-field>
            <our-data-field v-else label="Cap % * total student loans" label-width="3">
              {{ levyCollection.levyCap | percentage }} * {{ levyParameters.loanAmountsPaid | currency }}
              =
              {{ levyCalculation.levyCap | currency }}
            </our-data-field>
            <our-data-field label-width="3">
              <template slot="label">
                <span v-if="administrationFeeExempt">Administrative fee component</span>
                <a v-else class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelAdministrativeFeeBreakdown)">Administrative fee component</a>
                +
                <span v-if="riskRatingExempt">Risk rated premium component</span>
                <a v-else class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelRiskRatedPremiumBreakdown)">Risk rated premium component</a>
                +
                <span v-if="specialTuitionProtectionExempt">Special tuition protection component</span>
                <a v-else class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelSpecialTuitionProtectionBreakdown)">Special tuition protection component</a>
              </template>
              {{ levyCalculation.administrativeFeeComponent | currency }}
              +
              {{ levyCalculation.riskRatedPremiumComponent | currency }}
              +
              {{ levyCalculation.specialTuitionProtectionComponent | currency }}
              =
              {{ levyCalculation.totalLevyBeforeCap | currency }}
            </our-data-field>
            <our-data-field label-width="3" label="Levy cap adjustment">
              <template v-if="levyCalculation.capApplies">
                {{ levyCalculation.levyCap | currency }}
                -
                {{ levyCalculation.totalLevyBeforeCap | currency }}
                =
                {{ levyCalculation.levyCapAdjustment | currency }}
              </template>
              <template v-else>
                Not applicable
              </template>
            </our-data-field>
          </our-data-container>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";

export default {
  components: { PlaygroundUpDown },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    minimumCap() {
      return this.levyCalculation.levyCap == this.levyCollection.administrationFeePerProvider;
    }
  }
};
</script>
